import { createFileRoute } from '@tanstack/react-router';
import { NotificationManagementPage } from '@/components/features/notifications/NotificationManagementPage';

function Notifications() {
  return <NotificationManagementPage />;
}

export const Route = createFileRoute('/_authenticated/notifications')({
  component: Notifications,
});
